import { ReleaseOfInformation } from '@/types/releaseOfInformation';
import { RequestedFormCompletion } from '@/types/requestedFormCompletion';

export const filterDocumentsByRoiTerms = (
  documents: RequestedFormCompletion[],
  existingRois: ReleaseOfInformation[] = []
): RequestedFormCompletion[] => {
  const roiTerms = ['release', 'roi'];

  const existingRoiHealthieIds = new Set<string>();
  existingRois.forEach((roi) => {
    if (roi.form_answer_group_healthie_id !== null) {
      existingRoiHealthieIds.add(String(roi.form_answer_group_healthie_id));
    }
  });

  return documents.filter((doc) => {
    const hasRoiTerms = roiTerms.some(
      (term) =>
        String(doc.name).toLowerCase().includes(term) ||
        String(doc.description)?.toLowerCase().includes(term)
    );

    if (!hasRoiTerms) {
      return false;
    }

    // If it has ROI terms, check if it's already represented by an internal ROI object
    if (
      doc.form_answer_group_healthie_id &&
      existingRoiHealthieIds.has(String(doc.form_answer_group_healthie_id))
    ) {
      return false; // Exclude - this document is already represented by an internal ROI object
    }

    return true;
  });
};

export const getDocumentsByType = (
  documents: RequestedFormCompletion[],
  existingRois: ReleaseOfInformation[] = []
) => {
  const roiRelatedDocuments = filterDocumentsByRoiTerms(documents, existingRois);
  const otherDocuments = documents.filter(
    (doc) => !roiRelatedDocuments.some((roiDoc) => roiDoc.id === doc.id)
  );

  return {
    roiRelatedDocuments,
    otherDocuments
  };
};
